export * from './HotelPropertyInfo'
